import React from "react"
import { Card, Button, Form } from "react-bootstrap"
import { useVisitsPreferences } from "@/hooks/useLocalStorage"

type MapProvider = "google" | "osm" | "mapbox"

const providers: { value: MapProvider; label: string; description: string; icon: string }[] = [
    {
        value: "google",
        label: "Google Maps",
        description: "Alta calidad, requiere clave API y facturación activa.",
        icon: "fa-brands fa-google",
    },
    {
        value: "osm",
        label: "OpenStreetMap",
        description: "Gratuito, sin clave requerida. Ideal como alternativa.",
        icon: "fa-solid fa-map",
    },
    {
        value: "mapbox",
        label: "Mapbox",
        description: "Alta calidad con capa gratuita generosa. Requiere tu propio token.",
        icon: "fa-solid fa-location-dot",
    },
]

interface Props {
    show: boolean
    toggle: (section: string) => void
}

const MapProviderSettings: React.FC<Props> = ({ toggle }) => {
    const { mapProvider, setMapProvider, mapboxToken, setMapboxToken } = useVisitsPreferences()

    return (
        <div className="container mt-3">
            <Card className="shadow-sm mb-3">
                <Card.Header>
                    <Card.Title className="mb-0">
                        <i className="fa-solid fa-map me-2"></i>
                        Proveedor de Mapas
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <p className="text-muted small mb-3">
                        Selecciona el proveedor de mapas que prefieres usar. Esta preferencia se guarda en este dispositivo.
                    </p>
                    <div className="d-flex flex-column gap-2">
                        {providers.map(p => (
                            <div
                                key={p.value}
                                className={`border rounded p-3 cursor-pointer ${mapProvider === p.value ? "border-primary bg-primary bg-opacity-10" : "border-secondary"}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => setMapProvider(p.value)}
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <Form.Check
                                        type="radio"
                                        checked={mapProvider === p.value}
                                        onChange={() => setMapProvider(p.value)}
                                        onClick={e => e.stopPropagation()}
                                    />
                                    <i className={`${p.icon} fa-lg`} style={{ width: "20px" }}></i>
                                    <div>
                                        <div className="fw-semibold">{p.label}</div>
                                        <div className="text-muted small">{p.description}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {mapProvider === "mapbox" && (
                        <div className="mt-3">
                            <Form.Label className="fw-semibold">Token de Mapbox</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="pk.eyJ1IjoiLi4uIiwiYSI6Ii4uLiJ9..."
                                value={mapboxToken}
                                onChange={e => setMapboxToken(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                                Obtén tu token en{" "}
                                <a href="https://account.mapbox.com/access-tokens/" target="_blank" rel="noreferrer">
                                    account.mapbox.com
                                </a>
                                . El token se guarda solo en este dispositivo.
                            </Form.Text>
                        </div>
                    )}
                </Card.Body>
                <Card.Footer>
                    <Button variant="secondary" size="sm" onClick={() => toggle("")}>
                        Cerrar
                    </Button>
                </Card.Footer>
            </Card>
        </div>
    )
}

export default MapProviderSettings
